export default __webpack_public_path__ + "upper_arm.127908f7.png";